<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Close' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title class="modal-title">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    @if (customerReservationTransactionEmail.logoUrl || customerReservationTransactionEmail.logoFileName) {
      <ion-row class="center">
        <ion-col size="2"></ion-col>
        <ion-col size="8"><img style="width:125px;" logo></ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    <ion-row class="center bold">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        <h2 class="no-margin bold">{{customerReservationTransactionEmail.brandName}}</h2>
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>

    <ion-row class="center bold" style="padding-bottom:0!important;">
      <ion-col size="2" style="padding-bottom:0!important;"></ion-col>
      <ion-col size="12" style="padding-bottom:0!important;">
        <h3 class="no-margin">{{ 'Receipt.ShopAchat' | translate }}</h3>
      </ion-col>
      <ion-col size="2" style="padding-bottom:0!important;"></ion-col>
    </ion-row>
    <ion-row class="center bold no-padding">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        <h4 class="no-margin">{{ 'Receipt.ReservationReceipt' | translate }}</h4>
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="center bold no-padding">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        <h4 class="no-margin">{{ 'Receipt.Reservation' | translate }} #{{ customerReservationTransactionEmail.reservationNumber }}</h4>
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row>
      <!-- empty row-->
      &nbsp;
    </ion-row>
    <ion-row class="no-padding center uppercase">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{'Receipt.RecipientDetails' | translate}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding center bold uppercase">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerReservationTransactionEmail.customerName}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding center">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{ customerReservationTransactionEmail.billingAddress }}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding center bold uppercase">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerReservationTransactionEmail.customerPhone}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding center uppercase">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerReservationTransactionEmail.customerEmail}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    @if (!customerReservationTransactionEmail.onlyGiftCard) {
      <ion-row class="no-padding center uppercase">
        <ion-col size="2"></ion-col>
        <ion-col size="8">{{ customerReservationTransactionEmail.translations.paymentType }}:
        {{customerReservationTransactionEmail.ghostedPaymentNumber}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    @if (customerReservationTransactionEmail.useGiftCard) {
      <ion-row class="no-padding center uppercase">
        <ion-col size="2"></ion-col>
        <ion-col size="8">{{ customerReservationTransactionEmail.translations.giftCardPayment }}:
        {{customerReservationTransactionEmail.ghostedGiftCardNumber}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    <ion-row class="no-padding center uppercase">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        {{ 'Receipt.Date' | translate}}:{{moment(customerReservationTransactionEmail.createdDate).utcOffset(customerReservationTransactionEmail.createdDate).format("MM/DD/YYYY HH:mm:ss")}}
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row style="margin-top:15px; border-bottom: 1px solid black;"></ion-row>
    <ion-row class="bold">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerReservationTransactionEmail.storeName}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="bold">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerReservationTransactionEmail.storeAddress}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row style="border-bottom: 1px solid black;"></ion-row>
    <ion-row>
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{ 'Receipt.ReservationDate' | translate}}: {{ moment(customerReservationTransactionEmail.reservationDate).format("MM/DD/YYYY HH:mm") }}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="separator"></ion-row>

    @if (customerReservationTransactionEmail.reservation.specialRequest != '') {
      <ion-grid>
        <ion-row>
          <ion-col size="2"></ion-col>
          <ion-col size="8" style="color: red;">
            {{'Receipt.SpecialRequest' | translate}}: {{ customerReservationTransactionEmail.reservation.specialRequest }}
          </ion-col>
        </ion-row>
      </ion-grid>
    }
    @for (item of customerReservationTransactionEmail.reservation.packages; track item; let i = $index) {
      <ion-grid>
        <ion-row>
          <ion-col size="2"></ion-col>
          <ion-col size="5" [class.dotted-separator]="item.specialRequest == ''">
            <span>{{item.quantity}}x &nbsp;</span>{{item.name}}
          </ion-col>
          <ion-col size="2" class="right"
            [class.dotted-separator]="item.specialRequest == ''">
            {{ item.totalPrice | currency}}
          </ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
        @if (item.specialRequest != '') {
          <ion-row>
            <ion-col size="2"></ion-col>
            <ion-col size="8" class="dotted-separator">{{'Receipt.SpecialRequest' | translate}}:
              {{item.specialRequest}}
            </ion-col>
            <ion-col size="2"></ion-col>
          </ion-row>
        }
      </ion-grid>
    }
    <ion-row>
      <ion-col size="2"></ion-col>
      <ion-col class="separator" size="8"></ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding" style="margin-top:5px;">
      <ion-col size="2"></ion-col>
      <ion-col size="6">{{'General.Subtotal' | translate}}</ion-col>
      <ion-col class="right" size="2">{{ customerReservationTransactionEmail.subtotal | currency}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    @if (customerReservationTransactionEmail.isRebateApplied) {
      <ion-row>
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{'General.Promo' | translate}}</ion-col>
        <ion-col class="right" size="2">-{{ customerReservationTransactionEmail.rebateAmount | currency}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    @if (customerReservationTransactionEmail.convenienceFee > 0.00) {
      <ion-row class="no-padding">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{'Store.ConvenienceFee' | translate}}</ion-col>
        <ion-col class="right" size="2">{{ customerReservationTransactionEmail.convenienceFee | currency}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    @for (tax of customerReservationTransactionEmail.taxes; track tax) {
      <ion-row class="no-padding">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{ tax.name }}</ion-col>
        <ion-col class="right" size="2">{{ tax.amount | currency }}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    <ion-row class="no-padding">
      <ion-col size="2"></ion-col>
      <ion-col size="6">{{ 'Checkout.Tip' | translate}}</ion-col>
      <ion-col class="right" size="2">{{ customerReservationTransactionEmail.tip | currency}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding">
      <ion-col size="2"></ion-col>
      <ion-col size="6">{{'General.Total' | translate}}</ion-col>
      <ion-col class="right" size="2">{{ customerReservationTransactionEmail.total | currency}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    @if (customerReservationTransactionEmail.useGiftCard) {
      <ion-row class="no-padding">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{ customerReservationTransactionEmail.translations.giftCard }}</ion-col>
        <ion-col class="right" size="2">{{ customerReservationTransactionEmail.giftCardAmount | currency }}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    @if (customerReservationTransactionEmail.useGiftCard && !customerReservationTransactionEmail.onlyGiftCard) {
      <ion-row
        class="no-padding">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{ customerReservationTransactionEmail.translations.creditCard }}</ion-col>
        <ion-col class="right" size="2">{{ customerReservationTransactionEmail.creditCardAmount | currency }}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    @if (customerReservationTransactionEmail.gainedReward) {
      <ion-row>
        <ion-col size="12"><hr></ion-col>
      </ion-row>
      <ion-row  class="no-padding">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{ customerReservationTransactionEmail.translations.rewardCard }}</ion-col>
        <ion-col class="right" size="2">{{ customerReservationTransactionEmail.ghostedRewardCard }}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
      <ion-row class="no-padding">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{ customerReservationTransactionEmail.translations.gainedPoint }}</ion-col>
        <ion-col class="right" size="2">{{ customerReservationTransactionEmail.gainedPoint }}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
      <ion-row class="no-padding">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{ customerReservationTransactionEmail.translations.pointBalance }}</ion-col>
        <ion-col class="right" size="2">{{ customerReservationTransactionEmail.pointBalance }}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    <ion-row>
      <ion-col size="12"></ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12"></ion-col>
    </ion-row>
    <ion-row class="center">
      <ion-col size="12">{{'General.GST' | translate}}: {{customerReservationTransactionEmail.info.legalGst}}</ion-col>
    </ion-row>
    <ion-row class="center">
      <ion-col size="12">{{'General.PST' | translate}}: {{customerReservationTransactionEmail.info.legalQst}}</ion-col>
    </ion-row>
    <ion-row class="separator"></ion-row>
    <ion-row class="center">
      <ion-col size="12" class="bold">
        {{'Receipt.ImportantNote' | translate}}
      </ion-col>
    </ion-row>
    <ion-row></ion-row>
    <ion-row class="center">
      <ion-col size="12">
        {{'Receipt.ReservationReceiptNote' | translate}}
      </ion-col>
    </ion-row>
    <ion-row></ion-row>
    <ion-row class="center">
      <ion-col size="12">
        {{'Receipt.ReservationStorePhoneNumber' | translate}}
        &nbsp;
        <b>{{customerReservationTransactionEmail.storePhone}}</b>
      </ion-col>
    </ion-row>
    <ion-row class="center">
      <ion-col size="12">
        {{'Receipt.ReservationIdNote' | translate}}
      </ion-col>
    </ion-row>
    <ion-row class="center">
      <ion-col size="12">
        {{'Receipt.QuestionMayContact' | translate}}
      </ion-col>
    </ion-row>
    <ion-row class="center">
      <ion-col size="12">
        {{'Receipt.ChargeAppearAsFollow' | translate}}
      </ion-col>
    </ion-row>
    <ion-row class="separator"></ion-row>
    <ion-row class="center">
      <ion-col class="bold" size="12">
        {{'Receipt.ShopAchat' | translate}}
      </ion-col>
    </ion-row>
    <ion-row class="center">
      <ion-col size="12">
        {{customerReservationTransactionEmail.info.formatedAddress}}
      </ion-col>
    </ion-row>
    <ion-row class="center">
      <ion-col size="12">
        {{'Receipt.Contact' | translate}}: {{customerReservationTransactionEmail.info.contactEmail}}
      </ion-col>
    </ion-row>
    <ion-row class="center">
      <ion-col size="12">
        {{'Receipt.Tel' | translate}}: {{customerReservationTransactionEmail.info.phoneNumber}}
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>